import { render, staticRenderFns } from "./App.vue?vue&type=template&id=3f048022"
var script = {}
import style0 from "./assets/common.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports